import { render } from "./BrowseMain.vue?vue&type=template&id=7d792d60&scoped=true&lang=true"
import script from "./BrowseMain.vue?vue&type=script&lang=js"
export * from "./BrowseMain.vue?vue&type=script&lang=js"

import "./BrowseMain.vue?vue&type=style&index=0&id=7d792d60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d792d60"

export default script